<template>
  <div>
    <el-dialog :title="$t('customProduct.PayNow')" :visible="dialogTableVisible" @close="close" class="PaySampleFeeDialog" width="520px">
      <div class="paymentMethods">
        <div class="title f">
          <div style="flex-shrink: 0;">{{ $t('customProduct.Remark') }}:</div>
          <div style="margin-left:6px;word-break:keep-all;">{{ row.remark || '-' }}</div>
        </div>
        <div class="title">
          {{ $t('customProduct.TotalAmount') }}: <b>{{ currencySymbol }}{{ row.sampleFee }}</b>
        </div>
        <div class="PleaseSelectThePaymentMethod" style="border-top:1px solid #EFF1F7;padding-top:20px;">
          {{ $t('orderList.PleaseSelectThePaymentMethod')}}
        </div>
        <div class="radioSelect">
          <el-radio :label="2" v-model="radioValue">{{ $t('orderList.Paypal')}}</el-radio>
          <img class="pay-icon" src="@/assets/img/icon/paypal.png"/>
        </div>
        <!-- <div v-if="$store.state.common.userGroup === 100" class="radioSelect">
          <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
          <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
        </div>
        <div v-else class="radioSelect">
          <el-radio :label="9" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
          <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
        </div> -->
        <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
        <div class="radioSelect">
          <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
          <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
        </div>
        <div class="radioSelect">
          <el-radio :label="0" v-model="radioValue" :disabled="parseFloat(balance) < row.sampleFee">{{ `${$t('orderList.Balance')}  ${balance}` }}</el-radio>
        </div>
        <div class="radioSelect">
          <el-radio :label="3" v-model="radioValue">{{ $t('Publish.CustomProduct.List.Components.PaySampleFee.Others') }}</el-radio>
          <img class="pay-icon" src="@/assets/img/icon/zfb_wx.png"/>
        </div>
        <!-- <div class="payNow">
          <el-button type="primary" @click="confirm" style="width: 300px">{{ $t('Publish.CustomProduct.List.Components.PaySampleFee.PayNow') }}</el-button>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">{{$t('publishEdit.cancel')}}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Publish.CustomProduct.List.Components.PaySampleFee.PayNow') }}</el-button>
      </div>
    </el-dialog>
    <Paypal ref="paypal" @success="paySuccess" @fail="payFail" />
    <QianHai ref="qianhai" @success="paySuccess" @fail="payFail" />
    <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFail" />
    <Payoneer ref="payoneer" :payCallbackUrl="payoneerCallbackUrl" />
  </div>
</template>

<script>
import API from '@/api'
import Paypal from '@/components/Paypal.vue'
import QianHai from '@/components/QianHai.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'

export default {
  data() {
    return {
      dialogTableVisible: false,
      radioValue: 2,
      row: {
        sampleFee: 0
      }
    }
  },
  components: {
    Paypal, QianHai, Airwallex, Payoneer
  },
  computed: {
    balance() {
      if (this.$store.state.common.balance === undefined) this.$store.dispatch('common/getBalance')
      return this.$store.state.common.balance
    },
    address() {
      let address = {}
      if (this.$store.state.common.addressList.length) {
        address = this.$store.state.common.addressList[0]
      } else {
        this.$store.dispatch('common/getAddressList')
      }
      return address
    },
    payCallbackUrl() {
      return `${location.origin}/payment-status?state=success&orderId=${this.row.customPaymentRecordId}&paymentMethod=${this.radioValue}&paymentAmount=${this.row.sampleFee}`
    },
    payoneerCallbackUrl() {
      return `${location.origin}/payment-status?orderId=${this.row.customPaymentRecordId}`
    },
    currencySymbol() {
      return this.$store.state.common.currencySymbol
    }
  },
  methods: {
    async show(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.dialogTableVisible = true
    },
    close() {
      Object.keys(this.row).forEach(key => {
        this.row[key] = undefined
      })
      this.radioValue = 2
      this.dialogTableVisible = false
    },
    confirm() {
      const info = {
        amount: this.row.sampleFee || 11.1,
        paymentMethod: +this.radioValue === 4 ? 3 : this.radioValue,
        currencyCode: 'USD',
        paymentType: this.row.kkOrderId ? 0 : 2, //  2025.3.5 定制订单 有kkOrderId 改为正常下单参数，没有用原来定制参数
        kkOrderIds: [this.row.kkOrderId || this.row.customPaymentRecordId]
      }
      this.customProductTransaction(info)
    },
    // 生成交易单
    async customProductTransaction(info) {
      try {
        const res = await API.customProductTransaction(info)
        const addr = this.address
        this.paymentId = res.data
        switch (this.radioValue) {
          case 0:
            this.balancePayment(res.data)
            break
          case 1:
            this.$refs.qianhai.show({
              order_number: res.data, // 订单号
              order_amount: this.row.sampleFee, // 交易金额
              billing_lastName: addr.fullName, // 持卡人名
              billing_firstName: addr.fullName, // 持卡人姓
              billing_email: this.$store.state.common.email, // 持卡人邮箱
              billing_country: addr.countryCode, // 持卡人国家
              billing_state: addr.province, // 持卡人州/省
              billing_city: addr.city, // 持卡人城市
              billing_address: addr.streetAddressLine1, // 持卡人地址
              billing_zip: addr.zipCode, // 持卡人邮编
              productName: this.row.productName, // 产品名称
              productNum: 1, // 数量
              productSku: 'a'
            })
            break
          case 2:
            this.$refs.paypal.show(res.data)
            break
          case 3:
            this.$refs.airwallex.show(res.data, ['wechatpay', 'alipaycn'])
            break
          case 4:
            this.$refs.airwallex.show(res.data, ['card'])
            break
          case 9:
            this.$refs.payoneer.show(res.data)
            break
        }
      } catch (error) {
        this.$message.error({
          message: this.$message.error(this.$t('customProduct.transactionError')),
          customClass: 'zindex1000'
        })
      }
    },
    // paypal
    payFail() {
      this.$message.error(this.$t('orderDetail.payFail'))
    },
    // 支付成功回调
    paySuccess() {
      this.loading = false
      const query = {
        state: 'success',
        orderId: this.row.kkOrderId || this.paymentId,
        paymentAmount: this.row.sampleFee,
        paymentMethod: this.radioValue,
        payPage: 'custom'
      }
      this.$router.push({
        path: '/payment-status',
        query
      })
    },
    // 余额付款
    balancePayment(paymentId) {
      API.balancePayment(paymentId).then(result => {
        this.$store.dispatch('common/getBalance').then(() => this.paySuccess())
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.PaySampleFeeDialog {
    /deep/.el-dialog__body {
        padding-top: 0px;
        padding-bottom: 0px;
    }
}
.radioGroup {
    >div {
        margin-bottom: 6px
    }
}
.zindex1000 {
  z-index: 1000;
}
.paymentMethods{
  // border: 1px solid #CDD4DD;
  border-left: none;
  padding-top: 10px;
  margin-bottom: 14px;
  .payNow {
    margin-top: 40px;
  }
}
.radioSelect {
margin-bottom: 10px;
font-size: 14px;
display: flex;
  /deep/.el-radio{
    margin-right: 4px !important;
  }
  img{
    height: 16px;
  }
}
.PleaseSelectThePaymentMethod {
  // color: #747A87;
  margin-bottom: 12px;
  font-size: 14px;
  // font-weight: bold;
}
.title {
  font-size: 14px;
  // font-weight: bold;
  margin-bottom: 16px;
  line-height: 22px;
}
</style>

<style lang="scss">
.el-message {
  z-index: 10000 !important;
}
</style>
